module.exports = __webpack_public_path__ + "assets/b103.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b103.png
// module id = 574
// module chunks = 0